var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIncrease = function SvgIncrease(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F97316",
    fillRule: "evenodd",
    d: "M3.75 1H6a2.5 2.5 0 0 1 2.5 2.5v1.25C8.5 5.44 9.06 6 9.75 6H11a2.5 2.5 0 0 1 2.5 2.5v5.25c0 .69-.56 1.25-1.25 1.25h-8.5a1.25 1.25 0 0 1-1.25-1.25V2.25C2.5 1.56 3.06 1 3.75 1M6.5 11.5a.5.5 0 0 0-1 0v.5a.5.5 0 0 0 1 0zm1.5-2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2a.5.5 0 0 1 .5-.5m2.5-1a.5.5 0 0 0-1 0V12a.5.5 0 0 0 1 0z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F97316",
    d: "M9.5 3.5a3.5 3.5 0 0 0-.853-2.29 6.51 6.51 0 0 1 4.643 4.643A3.5 3.5 0 0 0 11 5H9.75a.25.25 0 0 1-.25-.25z"
  })));
};
export default SvgIncrease;